<template>
    <span
        :class="disabled ? 'module-disabled-struct' : ''"
        :uk-tooltip="
            disabled
                ? 'title:' + $t('x.module.disabled.hint', {x: $t('gallery')})
                : ''
        ">
        <span
            :class="
                disabled ? 'module-disabled uk-height-1-1' : 'uk-height-1-1'
            ">
            <License
                :license-link="settings.licenseLink"
                v-if="isDateStringPast(settings.clickAndBuyLicensedUntil)"
                :licensed-until="settings.clickAndBuyLicensedUntil"
                :description="$t(moduleName)"
                class="uk-margin-medium-bottom" />
            <div
                v-else-if="!settings.clickAndBuyLicensedUntil"
                class="uk-margin-medium-bottom">
                <InfoBox mode="primary" icon="info">
                    {{
                        $t('x.module.disabled.message', {
                            x: $t(moduleName),
                        })
                    }}
                </InfoBox>
            </div>

            <ul uk-tab="animation: uk-animation-fade">
                <li
                    v-for="tab in ['clickandbuys', 'design', 'license']"
                    :key="tab">
                    <a href="#">{{ $t(tab) }}</a>
                </li>
            </ul>
            <ul class="uk-switcher uk-margin">
                <li>
                    <InfoBox v-if="limitReached" icon="warning" mode="danger">
                        <Translate
                            translation-key="clickandbuy.limit.reached"
                            :parameter="{x: settings.clickAndBuyInfos.limit}" />
                    </InfoBox>
                    <div v-if="limitReached" class="uk-margin-medium-top" />

                    <span
                        :uk-tooltip="
                            'title:' +
                            (limitReached
                                ? $t('clickandbuy.limit.reached', {
                                      x: settings.clickAndBuyInfos.limit,
                                  })
                                : '')
                        ">
                        <Button
                            :action="actionNew"
                            :is-disabled="limitReached"
                            has-action
                            mode="primary">
                            {{ $t('x.add', {x: $t('clickandbuy')}) }}
                        </Button>
                    </span>

                    <div class="uk-margin-medium-top" />
                    <div v-if="!computedList || computedList.length === 0">
                        {{ $t('none.x', {x: $t('clickandbuys')}) }}
                    </div>
                    <div v-else class="uk-overflow-auto">
                        <table
                            class="uk-table uk-table-middle uk-table-divider uk-table-hover">
                            <thead>
                                <tr>
                                    <th class="uk-table-shrink">
                                        {{ $t('media') }}
                                    </th>

                                    <th class="uk-table-shrink">
                                        {{ $t('title') }}
                                    </th>

                                    <th class="uk-table-shrink">
                                        {{ $t('link') }}
                                    </th>
                                    <th class="uk-table-shrink">
                                        {{ $t('qr.code') }}
                                    </th>

                                    <th class="uk-table-shrink">
                                        {{ $t('price') }}
                                    </th>

                                    <th class="uk-table-shrink">
                                        {{ $t('file') }}
                                    </th>

                                    <th class="uk-table-shrink">
                                        {{ $t('description') }}
                                    </th>

                                    <th class="uk-table-shrink uk-text-nowrap">
                                        {{ $t('clickandbuy.email.text') }}
                                    </th>

                                    <th class="uk-table-shrink">
                                        {{ $t('active') }}
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr
                                    :id="item.id"
                                    v-for="(item, key) in computedList"
                                    :key="'clickandbuy-' + key"
                                    :class="
                                        'cursor-pointer uk-text-nowrap' +
                                        (item.id === hoveredId
                                            ? ' uk-table-hovered'
                                            : '')
                                    ">
                                    <td v-on:click="actionSelect(item)">
                                        <Modal
                                            is-extended
                                            :id="modalIdUpdate + item.id"
                                            :title="
                                                $t('x.change', {
                                                    x: $t(moduleName),
                                                })
                                            ">
                                            <ClickAndBuyForm
                                                :id="item.id"
                                                :settings="settings"
                                                @declared="actionGet"
                                                :modal-id="
                                                    modalIdUpdate + item.id
                                                "
                                                :click-and-buy="item"
                                                :disabled="disabled" />
                                        </Modal>

                                        <div
                                            class="uk-card uk-card-default uk-card-hover cursor-pointer">
                                            <div
                                                class="uk-inline uk-transition-toggle uk-width-1-1">
                                                <div v-if="item.mediaFileId">
                                                    <div
                                                        :data-src="
                                                            apiUrl +
                                                            '/manage-clickandbuys/' +
                                                            item.id +
                                                            '/media/' +
                                                            item.mediaFileId +
                                                            '?token=' +
                                                            getToken
                                                        "
                                                        class="thumbnail-height uk-background-cover"
                                                        uk-img />
                                                </div>
                                                <div v-else>
                                                    <div
                                                        class="thumbnail-height uk-flex uk-flex-center uk-flex-middle uk-background-cover">
                                                        {{
                                                            $t('no.x', {
                                                                x: $t('media'),
                                                            })
                                                        }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td v-on:click="actionSelect(item)">
                                        <Icon
                                            class="uk-margin-small-right"
                                            icon="hashtag" />
                                        {{ item.title }}
                                    </td>

                                    <td class="uk-text-center">
                                        <span
                                            class="cursor-pointer"
                                            v-on:click="
                                                actionLinkToClipboard(item)
                                            "
                                            :uk-tooltip="
                                                'title:' +
                                                $t('copy.to.clipboard')
                                            ">
                                            <Icon icon="copy-clipboard" />
                                        </span>
                                        <span
                                            class="uk-margin-small-left cursor-pointer"
                                            v-on:click="actionLinkOpen(item)"
                                            :uk-tooltip="'title:' + $t('open')">
                                            <Icon icon="link" />
                                        </span>
                                    </td>

                                    <td>
                                        <div
                                            :uk-tooltip="
                                                'title:' + $t('download')
                                            "
                                            class="qr-code"
                                            v-on:click="
                                                actionDownloadQRCode(item)
                                            "
                                            :id="
                                                'clickandbuyqrcode' + item.id
                                            " />
                                    </td>

                                    <td v-on:click="actionSelect(item)">
                                        <Icon
                                            class="uk-margin-small-right"
                                            icon="tag" />
                                        {{ getNumberWithCurrency(item.price) }}

                                        <Icon
                                            v-if="item.isPriceVariable"
                                            class="uk-margin-small-left"
                                            :uk-tooltip="
                                                'title:' + $t('variable.price')
                                            "
                                            icon="settings" />
                                    </td>

                                    <td v-on:click="actionSelect(item)">
                                        <Icon
                                            v-if="item.articleFileId"
                                            :uk-tooltip="
                                                'title:' +
                                                $t('with.x', {
                                                    x: $t('file'),
                                                })
                                            "
                                            icon="bag" />
                                        <Icon
                                            v-else
                                            :uk-tooltip="
                                                'title:' +
                                                $t('without.x', {
                                                    x: $t('file'),
                                                })
                                            "
                                            icon="close" />
                                    </td>

                                    <td v-on:click="actionSelect(item)">
                                        <Icon
                                            v-if="item.text"
                                            :uk-tooltip="
                                                'title:' +
                                                $t('with.x', {
                                                    x: $t('description'),
                                                })
                                            "
                                            icon="commenting" />
                                        <Icon
                                            v-else
                                            :uk-tooltip="
                                                'title:' +
                                                $t('without.x', {
                                                    x: $t('description'),
                                                })
                                            "
                                            icon="close" />
                                    </td>

                                    <td v-on:click="actionSelect(item)">
                                        <Icon
                                            v-if="item.emailText"
                                            :uk-tooltip="
                                                'title:' +
                                                $t('with.x', {
                                                    x: $t(
                                                        'clickandbuy.email.text'
                                                    ),
                                                })
                                            "
                                            icon="mail" />
                                        <Icon
                                            v-else
                                            :uk-tooltip="
                                                'title:' +
                                                $t('without.x', {
                                                    x: $t(
                                                        'clickandbuy.email.text'
                                                    ),
                                                })
                                            "
                                            icon="close" />
                                    </td>

                                    <td v-on:click="actionSelect(item)">
                                        <Icon
                                            v-if="item.disabled"
                                            :uk-tooltip="
                                                'title:' + $t('disabled')
                                            "
                                            icon="ban" />
                                        <Icon
                                            class="uk-text-success"
                                            v-else
                                            :uk-tooltip="
                                                'title:' + $t('active')
                                            "
                                            icon="bolt" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="uk-margin-medium-top" />

                    <div v-if="computedList && computedList.length > 0">
                        <span
                            :uk-tooltip="
                                'title:' +
                                (limitReached
                                    ? $t('clickandbuy.limit.reached', {
                                          x: settings.clickAndBuyInfos.limit,
                                      })
                                    : '')
                            ">
                            <Button
                                :action="actionNew"
                                :is-disabled="limitReached"
                                has-action
                                mode="primary">
                                {{ $t('x.add', {x: $t('clickandbuy')}) }}
                            </Button>
                        </span>
                    </div>
                </li>
                <li>
                    <div
                        class="uk-child-width-1-2@m uk-child-width-1-1 uk-grid-match"
                        uk-grid>
                        <div>
                            <ClickAndBuyNameForm
                                :text="settings.clickAndBuySettings.name" />
                        </div>
                        <div>
                            <ClickAndBuyTitleForm
                                :text="settings.clickAndBuySettings.title" />
                        </div>
                        <div>
                            <ClickAndBuyLogoForm
                                :click-and-buy-only="computedClickAndBuyOnly"
                                :data="getInfos.clickAndBuy.logo"
                                @updated="receiveInfos"
                                :allowed-extensions="fileExtensionsBackground"
                                :allowed-size="allowedFaviconSize" />
                        </div>
                        <div v-if="false">
                            <ClickAndBuyColorForm
                                :text="settings.clickAndBuySettings.color" />
                        </div>
                        <div>
                            <ClickAndBuyLinksForm
                                :text="settings.clickAndBuySettings.links" />
                        </div>
                    </div>
                </li>
                <li>
                    <div
                        class="uk-child-width-1-2@m uk-child-width-1-1 uk-grid-match"
                        uk-grid>
                        <div
                            v-if="!settings.clickAndBuyLicensedUntil"
                            class="uk-width-1-1">
                            <InfoBox mode="primary" icon="info">
                                {{
                                    $t('x.module.disabled.message', {
                                        x: $t(moduleName),
                                    })
                                }}
                            </InfoBox>
                        </div>
                        <div v-else class="uk-width-1-1">
                            <License
                                :license-link="settings.licenseLink"
                                :licensed-until="
                                    settings.clickAndBuyLicensedUntil
                                "
                                :description="$t(moduleName)" />
                        </div>
                    </div>
                </li>
            </ul>

            <Modal
                is-extended
                :id="modalIdCreate"
                :title="$t('x.add', {x: $t(moduleName)})">
                <ClickAndBuyForm
                    v-if="!loading"
                    id="new"
                    :settings="settings"
                    @declared="actionGet"
                    :modal-id="modalIdCreate"
                    :click-and-buy="{
                        id: null,

                        title: '',
                        text: '',

                        emailText: '',
                        mediaFileId: null,

                        articleFileId: null,
                        price: 0,

                        disabled: false,
                    }"
                    :disabled="disabled" />
            </Modal>
        </span>
    </span>
</template>

<script>
import License from '@/components/License.vue';
import InfoBox from '@/components/generic/InfoBox.vue';
import ClickAndBuyTitleForm from '@/views/clickandbuy/ClickAndBuyTitleForm.vue';
import ClickAndBuyColorForm from '@/views/clickandbuy/ClickAndBuyColorForm.vue';
import Translate from '@/components/Translate.vue';
import Button from '@/components/generic/Button.vue';
import UIkit from 'uikit';
import Modal from '@/components/generic/Modal.vue';
import ClickAndBuyForm from '@/views/clickandbuy/ClickAndBuyForm.vue';
import axios from 'axios';
import Icon from '@/components/generic/Icon.vue';
import QRCode from 'easyqrcodejs';
import Vue from 'vue';
import ClickAndBuyLogoForm from '@/views/clickandbuy/ClickAndBuyLogoForm.vue';
import ClickAndBuyNameForm from '@/views/clickandbuy/ClickAndBuyNameForm.vue';
import ClickAndBuyLinksForm from '@/views/clickandbuy/ClickAndBuyLinksForm.vue';

export default {
    name: 'ClickAndBuyAdmin',
    components: {
        ClickAndBuyLinksForm,
        ClickAndBuyNameForm,
        ClickAndBuyLogoForm,
        Icon,
        ClickAndBuyForm,
        Modal,
        Button,
        Translate,
        ClickAndBuyColorForm,
        ClickAndBuyTitleForm,
        InfoBox,
        License,
    },
    data() {
        return {
            moduleName: 'clickandbuy',

            modalIdCreate: 'modal-clickandbuy-create',
            modalIdUpdate: 'modal-clickandbuy-update-',

            selected: {},

            list: [],

            hoveredId: 0,

            qrCodes: [],
            loading: false,
        };
    },
    props: {
        settings: Object,
        disabled: Boolean,
    },
    created() {
        this.actionGet();
    },
    mounted() {
        this.generateQrCodes();
    },
    methods: {
        actionGetLink(clickandbuy) {
            if (this.settings.clickAndBuyInfos.domain) {
                return (
                    'https://' +
                    this.settings.clickAndBuyInfos.domain +
                    '/' +
                    this.$i18n.locale +
                    '/' +
                    clickandbuy.id
                );
            }

            return (
                window.location.origin +
                '/' +
                this.$i18n.locale +
                '/clickandbuys/' +
                clickandbuy.id
            );
        },
        generateQrCodes() {
            let self = this;
            setInterval(function () {
                for (let i = 0, j = self.computedList.length; i < j; i++) {
                    let clickandbuy = self.computedList[i];

                    if (self.computedQrCodes[clickandbuy.id]) {
                        return;
                    }

                    let refElement = document.getElementById(
                        'clickandbuyqrcode' + clickandbuy.id
                    );
                    if (!refElement) {
                        return;
                    }

                    let optionsDownload = {
                        text: self.actionGetLink(clickandbuy),
                        drawer: 'svg',
                    };

                    Vue.set(
                        self.qrCodes,
                        clickandbuy.id,
                        new QRCode(refElement, optionsDownload)
                    );
                }
            }, 50);
        },
        actionDownloadQRCode(clickandbuy) {
            this.computedQrCodes[clickandbuy.id].download(
                'clickandbuy ' + clickandbuy.title
            );
        },
        actionLinkOpen(clickandbuy) {
            let link = this.actionGetLink(clickandbuy);

            event.stopPropagation();
            event.preventDefault();
            window.open(link, '_blank').focus();
        },
        actionLinkToClipboard(clickandbuy) {
            let link = this.actionGetLink(clickandbuy);

            this.copyToClipboard(link);

            UIkit.notification({
                message: this.$t('copied.to.clipboard', {
                    description: this.$t('link'),
                }),
                status: 'info',
                pos: 'top-center',
                timeout: this.notificationTimeout,
            });
        },
        actionNew() {
            this.selected = {};
            UIkit.modal('#' + this.modalIdCreate).show();
        },
        actionSelect(select) {
            this.selected = select;
            UIkit.modal('#' + this.modalIdUpdate + select.id).show();
        },
        actionGet(id) {
            if (id) {
                this.hoveredId = id;
            }

            this.loading = true;
            let http = axios.create();
            http.get(this.apiUrl + '/manage-clickandbuys')
                .then((response) => {
                    if (response.data) {
                        this.list = response.data;
                    } else {
                        this.list = [];
                    }

                    this.qrCodes = [];

                    this.loading = false;
                })
                .catch((e) => {
                    this.checkGenericError(e);

                    this.error = e;
                });
        },
    },
    computed: {
        allowedFaviconSize() {
            if (this.settings.maxFileSizeForBackgroundPicturesInMB) {
                return this.settings.maxFileSizeForBackgroundPicturesInMB;
            }

            return 0;
        },
        fileExtensionsBackground() {
            if (this.settings.allowedFileExtensions) {
                return this.settings.allowedFileExtensions;
            }

            return [];
        },
        computedClickAndBuyOnly() {
            return (
                this.settings &&
                this.settings.clickAndBuyInfos &&
                this.settings.clickAndBuyInfos.only === true
            );
        },
        computedQrCodes() {
            return this.qrCodes;
        },
        computedList() {
            return this.list;
        },
        limitReached() {
            return (
                this.list &&
                this.settings.clickAndBuyInfos &&
                this.list.length >= this.settings.clickAndBuyInfos.limit
            );
        },
    },
};
</script>

<style lang="scss" scoped>
.thumbnail-height {
    height: 100px;
}

.qr-code {
    height: 80px;
    width: 80px;
}
</style>
